import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@components/login/login.component';
import { RouteGuardService } from '@services/route-guard.service';
import { LoginRouteGuardService } from '@services/login-route-guard.service';
import { LoadingMarginPointComponent } from '@components/loader-mp/loader-mp.component';
import { QbExtractorComponent } from '@components/qb-extractor/qb-extractor.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent, canActivate: [LoginRouteGuardService] },
  { path: 'loading', component: LoadingMarginPointComponent },
  { path: 'qbextractor', component: QbExtractorComponent, data: { orgFrom: 'im' } },
  { path: 'qbextractor/fs', component: QbExtractorComponent, data: { orgFrom: 'fs' } },
  { path: 'home', loadChildren: "./fs-lte/fs-lte.module#FsLTEModule", canLoad: [RouteGuardService], canActivate: [RouteGuardService] },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule { }
